module.exports = __webpack_public_path__ + "img/teladoc-icon.74f3b922.svg";